var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import OkCancelModal from './OkCancelModal';
import { messages } from './FilterSave';
export var FilterSaveModal = function (_a) {
    var isNameModalOpen = _a.isNameModalOpen, modalFilter = _a.modalFilter, saveFilter = _a.saveFilter, setModalFilter = _a.setModalFilter, setIsNameModalOpen = _a.setIsNameModalOpen;
    var formatMessage = useIntl().formatMessage;
    var closeModal = function () {
        setIsNameModalOpen(false);
        setModalFilter(undefined);
    };
    var handleNameInputKeyDownEvent = function (e) {
        if (e.keyCode === 13) {
            saveFilter();
        }
        else if (e.keyCode === 27) {
            closeModal();
        }
    };
    var onChange = function (e) {
        setModalFilter(__assign(__assign({}, modalFilter), { name: e.target.value }));
    };
    var nameInput = useMemo(function () { var _a; return (_a = modalFilter === null || modalFilter === void 0 ? void 0 : modalFilter.name) !== null && _a !== void 0 ? _a : ''; }, [modalFilter === null || modalFilter === void 0 ? void 0 : modalFilter.name]);
    if (isNameModalOpen) {
        return (_jsxs(OkCancelModal, __assign({ title: formatMessage(messages.SearchCriteriaNameInputTitle), show: true, onClose: closeModal, onSave: saveFilter, disableFullScreen: true }, { children: [_jsx("div", { children: formatMessage(messages.SearchCriteriaNameInputMessage) }), _jsx("div", { children: _jsx("input", { type: "text", value: nameInput, onChange: onChange, className: "form-control", maxLength: 50, autoFocus: true, onKeyDown: handleNameInputKeyDownEvent, placeholder: formatMessage(messages.SearchCriteriaNameInputPlaceholder) }) })] })));
    }
    return null;
};
